import { useQuery, useQueryClient } from '@tanstack/react-query'

import { DEFAULT_STALE_TIME } from '~/constants'
import { TAgent } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const useGetAgentsByOrgId = (orgId: string) => {
  const queryClient = useQueryClient()

  return useQuery({
    queryKey: queryKeys.agentsByOrganization(orgId),
    queryFn: () =>
      HttpService.get<TAgent[]>({
        path: EServerPath.agents,
        query: { orgId },
      }).then((res) => {
        if (res?.data?.length) {
          res.data.forEach((agent) => {
            queryClient.prefetchQuery({ queryKey: queryKeys.agent(agent.id) })
          })
        }

        return res
      }),
    retry: false,
    staleTime: DEFAULT_STALE_TIME,
    enabled: !!orgId,
  })
}

export default useGetAgentsByOrgId
